import store from "../state/store";

export default {
    install: function (Vue) {
        Vue.config.globalProperties.can = (ability) => store.getters['auth/can'](ability);
    }
}
